import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Button from '../../components/button/button';
import PasswordInput from '../../components/passwordInput/passwordInput';
import { useLogin } from '../../hooks/useLogin';

function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const { validateResetToken, error, success, resetPassword } = useLogin();

  useEffect(() => {
    validateResetToken(token);
  }, [token]);

  if (error) {
    return <p>{error}</p>;
  }

  if (success) {
    return <p>Passwort erfolgreich zurückgesetzt! Du wirst zur Login-Seite weitergeleitet.</p>;
  }

  return (
    <div className='pageContainer' style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <h1>Passwort zurücksetzen</h1>
      <form onSubmit={(e) => {
          e.preventDefault();
          resetPassword(token, password, passwordConfirm);
        }} 
        style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}
      >
        <PasswordInput
          labelFor='password'
          labelValue='Passwort: '
          inputId='password'
          inputValue={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          borderColor='black'
        />
        <br />
        <PasswordInput
          labelFor='passwordConfirm'
          labelValue='Passwort bestätigen: '
          inputId='passwordConfirm'
          inputValue={passwordConfirm}
          onChange={(e) => setPasswordConfirm(e.target.value)}
          required
          borderColor='black'
        />
        <br />
        <Button buttonType="submit" buttonValue='Passwort zurücksetzen' />
      </form>
    </div>
  );
}

export default ResetPassword;